import React from 'react';

const SaudePage: React.FC = () => {
  return (
    <div />
  );
};

export default SaudePage;
